import { Add } from "iconsax-react";
import styled, { css } from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 1.5rem;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};

  @media (max-width: 375px) {
    padding: 0;
  }
`;

export const InvalidMessage = styled.span`
  width: 100%;
  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;

export const RadioInput = styled.input`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 1.25rem;
  min-height: 1.25rem;
  margin: 0 0.75rem 0 0;

  outline: none;
  cursor: pointer;
  appearance: none;
  border-radius: 100%;
  border: 0.125rem solid #8c8c8c;

  position: absolute;
  z-index: -1;

  &:focus {
    box-shadow: 0 0 0.25rem ${(props) => `${props.theme?.colors?.textColor}a0`};
  }

  &::before {
    position: absolute;

    content: "";
    min-width: 0.75rem;
    min-height: 0.75rem;

    opacity: 0;
    border-radius: 100%;
    background: ${({ theme }) => theme.colors?.primary};

    transition: all ease-in-out 25ms;
  }

  &:checked {
    border: 0.125rem solid ${({ theme }) => theme.colors?.primary};
  }

  &:checked::before {
    opacity: 1;
  }
`;

interface IInputContainer {
  error: boolean;
  checked: boolean;
}

export const RadioContainer = styled.div<IInputContainer>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  min-height: 3.5rem;
  padding: 1rem;
  margin: 0 0 1rem;

  border-radius: 0.5rem;
  border: 0.125rem solid
    ${(props) =>
      props.error ? props.theme?.checkoutStepsOffers?.red : "transparent"};
  background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

  position: relative;

  &:hover {
    border: 0.125rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a0`};
  }

  ${(props) =>
    props.checked &&
    css`
      background: ${(props) =>
        props.theme?.checkoutStepsOffers?.inputBackground};

      border: 0.125rem solid
        ${(props) =>
          `${
            props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
            props.theme?.colors?.primary
          }a8`};
    `}
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: fit-content;
  margin: 1.25rem 0 0;

  border-radius: 0.25rem;
  box-shadow: 0.063rem 0.063rem 0.5rem
    ${(props) => `${props.theme?.checkoutStepsOffers?.placeholderColor}6f`};
`;

export const RadioContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
`;

export const Label = styled.label`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const CardIcon = styled.img`
  height: 1.475rem;
  margin: 0 0.625rem 0 0;
`;

export const AddNewCardButton = styled.button`
  display: flex;
  align-items: center;

  width: 100%;
  padding: 1rem;
  height: 3.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  border-radius: 0.5rem;
  border: 0.125rem solid transparent;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

  &:hover {
    border: 0.125rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a0`};
  }
`;

export const AddIcon = styled(Add)`
  margin: 0 0.625rem 0 0;

  size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
